import { useContentManagement } from "./ContentManagementProvider";
import { useState } from "react";
export const useFocus = (id) => {
    const [isHover, setIsHover] = useState(false);
    const { setActiveElement, activeElement, isEditing } = useContentManagement();
    if (!isEditing || id === null) {
        return {
            containerProps: {},
            isActive: false
        };
    }
    const handler = (event) => {
        setActiveElement(id);
        event.stopPropagation();
    };
    const hoverHandler = (event) => {
        setIsHover(true);
    };
    const blurHandler = (event) => {
        setIsHover(false);
    };
    return {
        containerProps: {
            onClick: handler,
            outline: activeElement === id ? "2px solid #0099ff" : isHover ? "2px solid #b8feff" : undefined,
            onMouseOver: hoverHandler,
            onMouseLeave: blurHandler
        },
        isActive: activeElement === id
    };
};
